import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

export const shareRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/share/$token",
  validateSearch: (search): { email?: string } => ({
    email: typeof search["email"] === "string" ? search["email"] : undefined,
  }),
  component: lazyRouteComponent(() => import("./share.page.js"), "SharePage"),
});
